module.exports = __webpack_public_path__ + "static/media/sslv1.c047f5de.png";